import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import VideoCard from "@/components/boost/VideoCard";
import AnimatedCounter from "@/components/boost/AnimatedCounter";
import { RESULTS_STATS } from "@/constants/content";
import { HOME } from "@/constants/testIds";

const RealResults = () => {
  const scrollReserve = () =>
    document.querySelector("#reserve")?.scrollIntoView({ behavior: "smooth" });

  return (
    <section id="results" className="section-pad relative overflow-hidden">
      <div className="container-x">
        <div className="flex flex-wrap items-end justify-between gap-4">
          <div className="max-w-2xl">
            <div className="chip">Real Store Results</div>
            <h2
              className="mt-3 font-display font-bold tracking-tight text-slate-900"
              style={{ fontSize: "clamp(2rem, 4vw, 3.25rem)" }}
            >
              Stores that started at zero — <span className="gradient-text-emerald">now doing real numbers</span>.
            </h2>
            <p className="mt-4 text-slate-600 max-w-xl">
              A quick look at what participants have shipped after the marathon.
              Not screenshots. Not testimonials. Actual stores, actual growth.
            </p>
          </div>
        </div>

        {/* Stats bento */}
        <div className="mt-10 grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-4">
          {RESULTS_STATS.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-10% 0px" }}
              transition={{ duration: 0.5, delay: i * 0.06 }}
              className={`rounded-3xl p-5 sm:p-6 border shadow-premium ${
                s.accent === "lime"
                  ? "bg-[#0f172a] text-white border-white/10"
                  : "bg-white text-slate-900 border-slate-100"
              }`}
            >
              <div
                className={`text-[11px] font-mono uppercase tracking-widest ${
                  s.accent === "lime" ? "text-lime-300" : "text-emerald-700"
                }`}
              >
                {s.label}
              </div>
              <div className="mt-2 font-display font-bold" style={{ fontSize: "clamp(2rem, 3.5vw, 3rem)", letterSpacing: "-0.02em" }}>
                <AnimatedCounter value={s.value} decimals={s.decimals || 0} suffix={s.suffix} />
              </div>
            </motion.div>
          ))}
        </div>

        {/* Videos */}
        <div className="mt-10 grid gap-5 sm:grid-cols-2">
          <VideoCard
            index={0}
            src="/assets/videos/store1.mp4"
            title="From zero to first ₹1L month"
            subtitle="Real Shopify store built during the marathon."
          />
          <VideoCard
            index={1}
            src="/assets/videos/store2.mp4"
            title="Scaling with Meta Ads"
            subtitle="Creative strategy + supplier flow — end to end."
          />
        </div>

        <div className="mt-10 flex flex-wrap justify-center gap-3">
          <button
            onClick={scrollReserve}
            data-testid={HOME.resultsCta}
            className="btn-primary text-base"
          >
            I Want Results Like This
            <ArrowUpRight className="w-4 h-4" />
          </button>
          <Link to="/results" className="inline-flex items-center gap-2 rounded-full border border-slate-200 bg-white px-6 py-3.5 text-base font-semibold text-slate-800 hover:bg-slate-50 transition">
            View Business Results
            <ArrowUpRight className="w-4 h-4" />
          </Link>
        </div>
      </div>
    </section>
  );
};

export default RealResults;
